import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function TopNav({ logo }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [showNav, setShowNav] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      
      // Show nav when scrolling up or at top, hide when scrolling down
      if (currentScrollY < lastScrollY || currentScrollY < 10) {
        setShowNav(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 50) {
        setShowNav(false);
        setMobileMenuOpen(false); // Close mobile menu when hiding nav
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <>
      <nav className={`
        bg-white
        md:relative
        fixed top-0 left-0 right-0 z-50
        transition-transform duration-300 ease-in-out
        ${showNav ? 'translate-y-0' : '-translate-y-full md:translate-y-0'}
      `}>
      <div className="flex justify-between items-center px-6 py-6 md:px-16 lg:px-24 max-w-7xl mx-auto">
        <Link to="/" className="flex items-center">
          <img src={logo || "/logo.svg"} className="h-7 w-7" alt="Veydra" />
          <span className="ml-2 text-xl font-medium text-gray-900 tracking-tight">Veydra</span>
        </Link>
        
        {/* Desktop navigation */}
        <div className="hidden md:flex items-center space-x-6">
          <Link to="/features" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Platform</Link>
          <Link to="/solutions" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Solutions</Link>
          <Link to="/resources" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Resources</Link>
          <Link to="/educators" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Educators</Link>
          <a href="https://app.veydra.io/pricing" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Pricing</a>
          <Link to="/book-demo" className="text-gray-600 hover:text-gray-900 text-sm font-medium">Book Demo</Link>
          <a href="https://app.veydra.io/login" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-5 py-2.5 rounded text-sm font-medium hover:bg-gray-800 transition-colors">Sign In</a>
        </div>

        {/* Mobile menu button */}
        <div className="flex items-center md:hidden">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 text-gray-600 hover:text-gray-900"
            aria-label="Toggle menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {mobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu dropdown */}
      {mobileMenuOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg z-50">
          <div className="px-8 py-4 space-y-4">
            <Link 
              to="/features"
              className="block py-2 text-gray-600 hover:text-gray-900 text-sm font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Platform
            </Link>
            <Link 
              to="/solutions"
              className="block py-2 text-gray-600 hover:text-gray-900 text-sm font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Solutions
            </Link>
            <Link 
              to="/resources"
              className="block py-2 text-gray-600 hover:text-gray-900 text-sm font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Resources
            </Link>
            <Link 
              to="/educators"
              className="block py-2 text-gray-600 hover:text-gray-900 text-sm font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Educators
            </Link>
            <a 
              href="https://app.veydra.io/pricing"
              target="_blank"
              rel="noopener noreferrer"
              className="block py-2 text-gray-600 hover:text-gray-900 text-sm font-medium"
            >
              Pricing
            </a>
            <Link 
              to="/book-demo"
              className="block py-2 text-gray-600 hover:text-gray-900 text-sm font-medium"
              onClick={() => setMobileMenuOpen(false)}
            >
              Book Demo
            </Link>
            <a 
              href="https://app.veydra.io/login"
              target="_blank"
              rel="noopener noreferrer"
              className="block py-2 text-gray-600 hover:text-gray-900 text-sm font-medium"
            >
              Sign In
            </a>
          </div>
        </div>
      )}
      </nav>
      {/* Spacer for fixed mobile nav */}
      <div className="h-[72px] md:hidden"></div>
    </>
  );
}

export default TopNav;
